import React, {useState} from 'react';
import {t} from '@lingui/core/macro';

import IServerOutput from 'features/server/model/Server/IServer';
import MainModal from 'shared/ui/Modal/MainModal';

import ServerForm from './ServerForm/ServerForm';
import ServerAgentConnectionScreen from './ServerAgentConnectionScreen/ServerAgentConnectionScreen';

interface IServerModalProps {
    open: boolean,
    item?: IServerOutput,
    handleClose: () => void,
}

const ServerModal: React.FC<IServerModalProps> = ({open, item, handleClose}) => {
    const [createdServer, setCreatedServer] = useState<IServerOutput | null>(null);

    const isNew = !item;

    const handleCloseAndReset = () => {
        handleClose();
        setCreatedServer(null);
    };

    const handleCreated = (server: IServerOutput) => {
        setCreatedServer(server);
    };

    const getHeader = () => {
        if (createdServer) {
            return t`Подключение агента`;
        }
        return isNew ? t`Создание сервера` : t`Редактирование сервера`;
    };

    return (
        <MainModal
            header={getHeader()}
            open={open}
            handleClose={handleCloseAndReset}
            size="md"
        >
            {
                createdServer
                    ? (
                        <ServerAgentConnectionScreen
                            token={createdServer.agent_token ?? ''}
                            serverUuid={createdServer.uuid}
                            onDone={handleCloseAndReset}
                        />
                    )
                    : (
                        <ServerForm
                            item={item}
                            onCreated={handleCreated}
                            onUpdated={handleCloseAndReset}
                            onClose={handleCloseAndReset}
                        />
                    )
            }
        </MainModal>
    );
};

export default ServerModal;
